
export const SHOP_NOW_CTA = {
  id: 'shop_now',
  key: 'module_adformat_shop_now',
};

/**
 * CA 编辑器新增的 CTA
 * 平台只用于预览的文案处理，不会披露给用户，hidden 在下拉选择列表中过滤掉
 * 这些 CTA 如果平台之后支持可以移到 TTCallToAction 并去掉 hidden 即可
 */
const CollectionAdsCTAs = [
  {
    id: 'pre_order_now_cta',
    key: 'module_adformat_pre_order_now_cta',
    hidden: true,
  },
  {
    id: 'interested_cta',
    key: 'module_adformat_interested_cta',
    hidden: true,
  },
  {
    id: 'install_now_cta',
    key: 'module_adformat_install_now_cta',
    hidden: true,
  },
  {
    id: 'get_showtimes_cta',
    key: 'module_adformat_get_showtimes_cta',
    hidden: true,
  },
  {
    id: 'listen_now_cta',
    key: 'module_adformat_listen_now_cta',
    hidden: true,
  },
  {
    id: 'subscribe_cta',
    key: 'module_adformat_subscribe_cta',
    hidden: true,
  },
  {
    id: 'get_tickets_now_cta',
    key: 'module_adformat_get_tickets_now_cta',
    hidden: true,
  },
  {
    id: 'read_more_cta',
    key: 'module_adformat_read_more_cta',
    hidden: true,
  },
  {
    id: 'experience_now_cta',
    key: 'module_adformat_experience_now_cta',
    hidden: true,
  },
  {
    id: 'order_now_cta',
    key: 'module_adformat_order_now_cta',
    hidden: true,
  },
  {
    id: 'view_now_cta',
    key: 'module_adformat_view_now_cta',
    hidden: true,
  },
  {
    id: 'visit_store_cta',
    key: 'module_adformat_visit_store_cta',
    hidden: true,
  },
  {
    id: 'get_quote_cta',
    key: 'module_adformat_get_quote_cta',
    hidden: true,
  },
];
/**
 * id为平台传给后端的value
 * key对应平台的多语言配置
 * { call_to_action: ${id} }
 */

// 竞价 TT call_to_action 文案
export const TTCallToAction = [
  {
    id: 'learn_more',
    key: 'module_adformat_learn_more',
  },
  {
    id: 'download_now',
    key: 'module_adformat_download_now',
  },
  SHOP_NOW_CTA,
  {
    id: 'sign_up',
    key: 'module_adformat_sign_up',
  },
  {
    id: 'contact_us',
    key: 'module_adformat_contact_us',
  },
  {
    id: 'apply_now',
    key: 'module_adformat_apply_now',
  },
  {
    id: 'book_now',
    key: 'module_adformat_book_now',
  },
  {
    id: 'play_game_cta',
    key: 'module_adformat_play_game',
  },
  {
    id: 'watch_now',
    key: 'module_adformat_watch_now',
  },
  {
    id: 'read_more',
    key: 'module_adformat_read_more',
  },
  {
    id: 'view_now',
    key: 'module_adformat_view_now',
  },
  {
    id: 'get_quote',
    key: 'module_adformat_get_quote',
  },
  {
    id: 'order_now',
    key: 'module_adformat_order_now',
  },
  {
    id: 'install_now',
    key: 'module_adformat_install_now',
  },
  {
    id: 'get_showtimes',
    key: 'module_adformat_get_showtimes',
  },
  {
    id: 'listen_now',
    key: 'module_adformat_listen_now',
  },
  {
    id: 'interested',
    key: 'module_adformat_interested',
  },
  {
    id: 'subscribe',
    key: 'module_adformat_subscribe',
  },
  {
    id: 'get_tickets_now',
    key: 'module_adformat_get_tickets_now',
  },
  {
    id: 'experience_now',
    key: 'module_adformat_experience_now',
  },
  {
    id: 'preorder_now',
    key: 'module_adformat_preorder_now',
  },
  {
    id: 'visit_store',
    key: 'module_adformat_visit_store',
  },
  {
    id: 'brand_lift_study',
    key: 'module_adformat_brand_lift_study',
  },
  {
    id: 'view_profile',
    key: 'adformat_view_profile',
  },
  {
    id: 'join_this_hashtag',
    key: 'module_adformat_join_this_hashtag',
  },
  {
    id: 'view_video_with_this_effect',
    key: 'module_adformat_view_video_with_this_effect',
  },
  {
    id: 'shoot_with_this_effect',
    key: 'module_adformat_shoot_with_this_effect',
  },
];

// Dynamic CTA 非英语国家候选集合
export const CALL_TO_ACTION_NOT_EN = [
  ...TTCallToAction,
  {
    id: 'play_button',
    key: 'module_adformat_play_appname',
  },
  {
    id: 'play_now_button',
    key: 'module_adformat_play_appname_now',
  },
  {
    id: 'download_button',
    key: 'module_adformat_download_appname',
  },
  {
    id: 'install_button',
    key: 'module_adformat_install_appname',
  },
  {
    id: 'install_now_button',
    key: 'module_adformat_install_appname_now',
  },
  {
    id: 'go_to_app_store_button',
    key: 'module_adformat_goto_appstore',
  },
  {
    id: 'go_to_google_play_button',
    key: 'module_adformat_goto_google_play',
  },
];

export const SHOP_LIVE_CTA = {
  id: 'watch_live',
  key: 'module_creative_watch_live',
};

/**
 * 所有 CTAs，主要用于预览的翻译
 * 包含了 CA 不用披露的部分
 */
export const AllCallToActions = [
  ...TTCallToAction,
  ...CollectionAdsCTAs,
  SHOP_LIVE_CTA,
];

// CTA类型
export const ADVANCED_CREATIVE_TYPE = {
  customization: 12, // 自定义CTA（下拉框选择CTA）
  autoOptimized: 60, // 智能优选（弹窗选择多个CTA，然后后台通过模型分配推荐的CTA）
  collectionAds: 54, // collection ads 对应的值
  default: 11, // cat智能优选默认用这个值，在cta优选组件初始化的时候，改为autoOptimized:60
};

// 目前仅支持，投放地美国、英国、澳大利亚、加拿大
export const CTA_OPTIMIZED_SUPPORT_COUNTRY = [
  '6252001', // 美国
  '2635167', // 英国
  '2077456', // 澳大利亚
  '6251999', // 加拿大
];
